import { Box, Flex, HStack, Image, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { EXPERIENCES } from '../../../constants/companies';
import { t } from '../../../locales/locales';
import { appColors } from '../../../constants/theme';

const HomeExperiences = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Text fontSize={12} fontWeight={600} color="white" textAlign={'center'}>
        {t('experiences')}
      </Text>
      <HStack alignItems={'center'} justifyContent={'center'}>
        {EXPERIENCES.map((company) => (
          <Flex
            key={company.id}
            align="center"
            cursor="pointer"
            onClick={(e) => {
              e.stopPropagation();
              navigate('/experiences', {
                state: { scrollTo: company.id },
              });
            }}
            _hover={{
              transform: 'scale(1.1)',
              color: appColors.primary,
              filter: `drop-shadow(0 0 6px ${appColors.primary})`,
            }}
          >
            <Image
              src={company?.icon}
              zIndex={2}
              pointerEvents="none"
              h={company?.h}
              w={company?.w}
              objectFit="contain"
            />
          </Flex>
        ))}
      </HStack>
    </Box>
  );
};

export default HomeExperiences;
